import React, { useState } from 'react';

import { useSelector } from 'react-redux';

import { Form, Input, Button, Modal } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import withTranslations from 'app/components/HOGs/withTranslations';

import { academyAPI } from 'app/API/academy.api';

import {
  openNotificationWithIcon,
  cachHandler,
} from 'app/components/Utility/notificationMessage';

const WriteToUs = ({ state, changeState, lists, tr }) => {
  const { writeToUsModalShow, activeLesson, activeListKey } = state;

  const { active } = useSelector((state) => state.languageData);

  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const handleCancel = () => changeState({ writeToUsModalShow: false });

  const handleSubmit = (values) => {
    const activeList = lists.filter((x) => x.id === activeListKey)[0];

    const getCountry = () => {
      if (active && typeof active === 'string') {
        if (active.toUpperCase() === 'EN') {
          return 'GB';
        }
        return active.toUpperCase();
      }

      return 'GB';
    };

    const { email, mess, name } = values;
    const textActiveList = `Tourstart Academy list: <a href="${process.env.API_URL}/createtour?scope=academy&list=${activeList.id}">${activeList.title}</a>;`;
    const textActiveLesson = `Tourstart Academy lesson: <a href="${process.env.API_URL}/createtour?scope=academy&list=${activeList.id}&lesson=${activeLesson.id}">${activeLesson.title}</a>;`;
    const text = `Message: ${mess}; <br/><br/> ${textActiveList} <br/> ${textActiveLesson}`;
    const country = getCountry();

    academyAPI
      .sendFeedback(name, email, text, country)
      .then((res) => {
        const { code, message } = res;
        if (code === 200) {
          openNotificationWithIcon('success', message || tr.Success);
          changeState({ writeToUsModalShow: false });
          form.resetFields();
        } else {
          cachHandler(res);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        cachHandler(err);
      });
  };

  return (
    <Modal
      visible={writeToUsModalShow}
      centered
      onCancel={() => handleCancel()}
      footer={[
        <Button key="back" onClick={() => form.submit(handleSubmit)}>
          {loading ? <LoadingOutlined /> : tr.Send}
        </Button>,
      ]}
      className="writeToUsModal"
      width={400}
      closable
    >
      <Form onFinish={handleSubmit} form={form}>
        <Form.Item
          label={tr['Write to us']}
          name="name"
          rules={[
            {
              required: true,
              message: tr['Write your name'],
            },
          ]}
        >
          <Input placeholder={tr['Your name']} />
        </Form.Item>

        <Form.Item
          label={tr['E-mail']}
          name="email"
          rules={[
            {
              type: 'email',
              message: tr['E-mail is not valid'],
            },
            {
              required: true,
              message: tr['Write your e-mail'],
            },
          ]}
        >
          <Input placeholder={tr['Your e-mail']} />
        </Form.Item>

        <Form.Item
          label={tr.Message}
          name="mess"
          rules={[
            {
              required: true,
              message: tr['Write your message'],
            },
          ]}
        >
          <Input.TextArea placeholder={tr['Your message']} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default withTranslations(WriteToUs);
